import React from 'react';
import { Button, Tooltip, TooltipContainer, TooltipTarget } from 'is24-corecss';
import { IconS24InfoCircle24 } from '@is24/cosma-ui-icons';
import './EfficiencyClass.styles.css';
import { reportModernizationCostsCalculionEvent } from '../../tracking/tracking';
import { useGetModernizationButtonVisibilityQuery } from '../../services/modernization-button-visibility-api';

const disabledExplanationText = {
  MODERNIZATION_CALCULATION_NOT_NEEDED: 'Aufgrund des guten energetischen Zustands ist eine Modernisierung nicht erforderlich.',
  MODERNIZATION_CALCULATION_MISSING_DATA:
    'Eine Berechnung der Modernisierungsmaßnahmen ist aufgrund fehlender Informationen zur Immobilie nicht möglich.',
  MODERNIZATION_CALCULATION_NOT_SUPPORTED: 'Die Berechnung einer Modernisierung ist für diese Immobilie nicht möglich.',
  MODERNIZATION_CALCULATION_DEACTIVATED: 'Der Modernisierungsrechner wurde für diese Immobilie deaktiviert.',
  MODERNIZATION_CALCULATION_DEACTIVATED_BY_PROVIDER: 'Eine Modernisierung ist für diese Immobilie laut der:s Anbieterin:s nicht erforderlich.',
};

const EfficiencyButton = ({ exposeId, lastModificationDate }: { exposeId: string, lastModificationDate?: string }) => {
  const { data, error } = useGetModernizationButtonVisibilityQuery({ exposeId, lastModificationDate });

  const exposeModernizationLink = `${process.env.BASE_URL}/modernisierungsrechner/result?exposeId=${exposeId}&cmp_id=10-052425&cmp_name=esg_modernization_calculator&cmp_position=residential_expose&cmp_creative=modernization_calc_button`;

  const handleClick = () => {
    window.open(exposeModernizationLink, '_blank');
  };

  return (
    <div style={{ height: '40px' }}>
      {!error && data?.buttonAvailabilityDetails.buttonVisible && (
        <div style={{ display: 'inline-flex' }}>
          <Button
            onClick={() => {
              reportModernizationCostsCalculionEvent();
              handleClick();
            }}
            appearance='secondary'
            disabled={!data.buttonAvailabilityDetails.buttonEnabled}
          >
            Modernisierungskosten berechnen
          </Button>
          {!data.buttonAvailabilityDetails.buttonEnabled && (
            <div style={{ width: 'fit-content' }}>
              <TooltipContainer className='margin-left-s margin-top-s'>
                <TooltipTarget className='font-lightgray font-l align-center'>
                  <IconS24InfoCircle24 color='#757575' width={24} height={24} />
                </TooltipTarget>
                <Tooltip bodyPosition='bottom' arrowPosition={'right'}>
                  <div className='dark-font font-xs' style={{ height: 40, width: 250 }}>
                    {disabledExplanationText[data.buttonAvailabilityDetails.result as unknown as keyof typeof disabledExplanationText]}
                  </div>
                </Tooltip>
              </TooltipContainer>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EfficiencyButton;
